module.exports = __webpack_public_path__ + "static/media/MegaMan.36d95a1a.jpg";